module.exports = __webpack_public_path__ + "img/6.0a52e8c9.jpg";